(function ($) {
    /**
     * Set cookie
     *
     * @param key
     * @param value
     */
    function setCookie(key, value) {
        document.cookie = key + '=' + value + ';path=/';
        location.reload();
    }

    /**
     * Method to get the value of a cookie
     * From https://stackoverflow.com/questions/10730362/get-cookie-by-name
     *
     * @param name
     * @returns {*}
     */
    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        } else {
            return '';
        }
    }

    /**
     * Delete cookie
     *
     * @param key
     */
    function deleteCookie(key) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * -1);

        document.cookie = key + '=;path=/;expires=' + d.toGMTString();
        location.reload();
    }

    const cookieKey = 'manipulatedEntraId',
        $entraIdValue = $('[data-entraidtraveler-value]');

    let currentCookieValue = getCookie(cookieKey);

    // Check the correct cookie first
    if (currentCookieValue !== '') {
        $entraIdValue.val(currentCookieValue);
    }

    // Submit override for deleting / setting the cookie
    $('[data-entraidtraveler]').submit(function (event) {
        event.preventDefault();

        let entraIdValue = $entraIdValue.val();

        // Delete cookie if value is empty; otherwise set the cookie
        if (entraIdValue === '') {
            deleteCookie(cookieKey);
        } else {
            setCookie(cookieKey, entraIdValue);
        }

        return false;
    });
})(jQuery);